<template>
  <div class="mb-12 md:mb-36">
    <div @click="prev" v-if="current > 1" class="h-screen-1/2 hidden md:block fixed left-0 right-0 top-0 cursor-n-resize"></div>
    <div @click="advance" class="h-screen-1/2 hidden md:block fixed left-0 right-0 bottom-0 cursor-s-resize"></div>

    <div ref="anchors" class="md:flex flex-wrap md:-mt-8">
      <article v-for="(post, index) in posts" :id="post.domId" :data-idx="index" class="md:w-1/2 desk-news md:px-8 scroll-mt-screen-1/2 pb3 md:pb-0">
        <div class="mb3 sm-mb4 max-w-md md:mx-[2vw] relative">
          <figure v-if="post.acf.thumbnail" class="m0 pb2 desk-img">
            <responsive-image :src="post.acf.thumbnail" :alt="post.title.rendered"></responsive-image>
          </figure>

          <div class="relative">
            <h2 class="h4 m0 regular flex justify-between">
              <span class="underline">{{ post.title.rendered }}</span>
              <span class="">{{ dateFormat(post.date) }}</span>
            </h2>
            <div class="relative">
              <div v-html="post.content.rendered" class="justify"></div>
              <v-waypoint @waypoint-in="waypointIn(index)" class="waypoint"></v-waypoint>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import fecha from 'fecha'
  import store from '@/store'

  export default {
    name: 'news',
    metaInfo: { title: 'News · Maich Swift Architects' },
    data () {
      return { current: null }
    },
    computed: {
      posts () {
        return this.$store.state.posts.map((p) => {
          p.domId = `${p.slug}-${p.id}`
          return p
        })
      },
      anchors () {
        return this.$refs.anchors.children
      }
    },
    methods: {
      dateFormat (d) {
        return fecha.format(new Date(d), 'DD.MM.YYYY')
      },
      anchor (id) {
        return `#${id}`
      },
      active (id) {
        return id === this.current ? 'router-link-active' : false
      },
      waypointIn (id) {
        if (id % 2) return
        this.current = id
      },
      canAdvance (idx) {
        return idx < this.posts.length - 1
      },
      prev () {
        const el = this.anchors[this.current - 2]
        if (!el) return

        el.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      },
      advance () {
        const el = this.anchors[this.current + 2]
        if (!el) {
          const top = this.anchors[0]
          if (!top) return
          top.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          })
          return
        }

        el.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      }
    },
    beforeRouteEnter (to, from, next) {
      store.dispatch('getPosts').then(() => {
        next()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/News.vue